// extracted by css-extract-rspack-plugin
export default {"imageWrapper":"_4dd3b1fd","image":"_ef36528e","instructionalText":"_114fa8a1"};